import React from 'react';
import './FaqButton.styles.css';

interface FaqButtonProps {
  onOpenDrawer: () => void;
}

export const FaqButton: React.FC<FaqButtonProps> = ({ onOpenDrawer }) => {
  return (
    <button
      role="button"
      id="faq-support-button"
      className="support-button"
      aria-expanded="false"
      aria-controls="faq-drawer-title"
      onClick={onOpenDrawer}
      aria-label="Open frequently asked questions"
    >
      <div className="button-inner">
        <div className="icon-container">
          <svg width="13" height="15" viewBox="0 0 13 15">
            <path
              d="M11.8182 0H1.18182C0.529118 0 0 0.610521 0 1.36364V13.6364C0 14.3895 0.529118 15 1.18182 15H11.8182C12.4709 15 13 14.3895 13 13.6364V1.36364C13 0.610521 12.4709 0 11.8182 0Z"
              fill="#FFFFFF"
            />
            <path
              d="M3.11869 4.01514H9.88131"
              stroke="#039be5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.11869 7.65151H9.88131"
              stroke="#039be5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.11869 11.2879H9.88131"
              stroke="#039be5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="button-text">Frequently Asked Questions</div>
      </div>
    </button>
  );
};

export default FaqButton;
